module.exports = __webpack_public_path__ + "static/case03-6fcbfd1cd3544a655e9a2dcb78921128.jpg";